type Version = { id: string; name: string }

// Common types

export type Cost = {
  id: string
  versionId: string
  value: number
  multiplier: number | null
}

export type CostRow = FixedCostRow | EnergyCostRow
export const isFixedCostRow = (row: CostRow): row is FixedCostRow =>
  (row as FixedCostRow).providerName !== undefined &&
  (row as FixedCostRow).description !== undefined

export type GroupedCost = {
  name: string
  versions: Version[]
  costRows: CostRow[]
}

// Fixed cost types

export type FixedCostRow = {
  providerName: string
  description: string
  costs: Cost[]
}
export type GroupedFixedCost = {
  name: string
  versions: Version[]
  costRows: FixedCostRow[]
}

// Energy cost types

export type EnergyCostRow = {
  translationKey: string
  costs: Cost[]
}

export type GroupedEnergyCost = {
  name: string
  versions: Version[]
  costRows: EnergyCostRow[]
}

// Other types

export type TotalCostsRowData = {
  versionId: string
  sum: number | null
}
